<template>
  <div style="width: 100%">
    <Upload
      ref="upload"
      :action="api"
      :with-credentials="true"
      :show-upload-list="false"
      :on-success="handleSuccess"
      :on-error="handleError"
      :format="['jpg','jpeg','png','gif']"
      :max-size="5120"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :before-upload="handleBeforeUpload"
    >
      <i-button icon="ios-cloud-upload-outline">上传图片</i-button>
    </Upload>
    <div class="imgBox" v-if="imgUrl">
      <div class="active">
        <Icon type="md-close" @click="close()" />
      </div>
      <div v-if="imgUrl">
        <img :src="imgUrl" @load="imgLoad()" style="width:200px;" alt />
      </div>
      <Spin fix v-show="loading"></Spin>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.imgBox {
  width: 100%;
  min-height: 100px;
  position: relative;
  text-align: center;
  background-color: #eee;
  .active {
    padding: 10px;
    text-align: right;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 24px;
    color: #fff;
  }
}
</style>

<script>
import { BaseUrl } from "../http/config";

export default {
  data() {
    return {
      api: BaseUrl+"/api/upload?dir=newSite",
      loading: true,
      active: true
    };
  },
  props: ["imgUrl"],
  methods: {
    handleMaxSize() {
      this.active = false; // 关闭图片部分
      // 文件超出大小
      this.$Notice.warning({
        title: "图片过大",
        desc: "图片超出支持大小"
      });
    },
    handleFormatError() {
      // this.active = false; // 关闭图片部分
      // 文件格式错误
      this.$Notice.warning({
        title: "图片格式错误",
        desc: `只支持：'jpg','jpeg','png'`
      });
    },
    handleBeforeUpload() {
      // 上传文件之前的钩子
      // alert("上传之前的钩子");
      this.active = true; // 开启图片部分
    },
    handleSuccess(response, file, fileList) {
      // 图片地址 图片对象 图片数组
      // 上传成功
      // this.imgUrl = file.response;
      this.$emit("success", file.response);
      this.loading = true; // 开启图片加载
      this.$Notice.success({
        title: "上传成功",
        desc: ""
      });
    },
    handleError(error, file, fileList) {
      // 上传失败
      this.active = false; // 关闭图片部分
      this.$Notice.warning({
        title: "接口异常",
        desc: `返回：${error || "没有返回"}`
      });
    },
    imgLoad() {
      // 图片加载完毕
      this.loading = false; // 加载完毕关闭load
    },
    close() {
      this.active = false; // 关闭图片模块
      this.$emit("close");
    }
  }
};
</script>